import type { TersaImageModel } from '../../types';
import { relightModels } from './relight';
import { davinciModels } from './davinci';

export const flowmuseModels: Record<string, TersaImageModel> = {
  ...relightModels,
  ...davinciModels,
};